<template>
    <div class="filter-options">
        <div class="row">
            <!-- Kavel filters -->
            <div class="mb-4" :class="!!(person ^ item) ? 'col-12' : 'col-md-6 col-12 mb-4'" v-if="item">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center">
                            <span class="filter-options-heading flex-grow-1">
                                Kavel filters
                            </span>

                            <b-button
                                type="button"
                                variant="primary"
                                v-b-tooltip.hover
                                title="Reset kavel filters"
                                @click="clearForm('item')"
                            >
                                    <fa-icon icon="redo" />
                            </b-button>
                        </div>
                        <hr>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-12">
                        <general-input
                            v-model="form.item.title_description"
                            label="Titel / omschrijving"
                            placeholder="Zoek in titel en/of omschrijving"
                            @input="emitValue"
                        />
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-4">
                        <general-input
                            v-model="form.item.auction_order_number"
                            label="Lotnummer"
                            placeholder="Zoek op lotnummer"
                            @input="emitValue"
                        />
                    </div>

                    <div class="col-8">
                        <label class="filter-options-label">
                            Tag
                        </label>
                        <multiselect
                            v-model="selectedTag"
                            :options="tagOptions"
                            :loading="isFetchingTags"
                            label="name"
                            track-by="id"
                            @input="emitValue"
                            placeholder="Zoek binnen een tag"
                        />
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-12">
                        <label class="filter-options-label">
                            Categorie
                        </label>
                        <multiselect
                            v-model="selectedCategory"
                            :options="categoryOptions"
                            :loading="isFetchingCategories"
                            label="title"
                            track-by="id"
                            @input="emitValue"
                            placeholder="Zoek binnen een categorie"
                        />                        
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label class="filter-options-label">
                            Veiling
                        </label>
                        <multiselect
                            v-model="selectedAuction"
                            :options="auctionOptions"
                            :loading="isFetchingAuctions"
                            label="title"
                            track-by="id"
                            @input="emitValue"
                            placeholder="Zoek binnen een veiling"
                        />                        
                    </div>
                </div>
            </div>

            <!-- Persoon filters -->
            <div class="mb-4" :class="!!(person ^ item) ? 'col-12' : 'col-md-6 col-12'" v-if="person">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center">
                            <span class="filter-options-heading flex-grow-1">
                                Persoon filters
                            </span>

                            <b-button
                                type="button"
                                variant="primary"
                                v-b-tooltip.hover
                                title="Reset persoon filters"
                                @click="clearForm('person')"
                            >
                                    <fa-icon icon="redo" />
                            </b-button>
                        </div>
                        <hr>
                    </div>
                </div>

                <div class="row">
                    <div class="mb-2" :class="item ? 'col-6' : 'col-lg-6 col-xl-3'">
                        <general-input
                            v-model="form.person.code"
                            label="Inbrengcode"
                            placeholder="Zoek op inbrengcode"
                            @input="emitValue"
                        />
                    </div>

                    <div class="mb-2" :class="item ? 'col-6' : 'col-lg-6 col-xl-3'">
                        <general-input
                            v-model="form.person.name"
                            :label="item ? 'Inbrenger naam' : 'Naam'"
                            placeholder="Zoek op naam"
                            @input="emitValue"
                        />
                    </div>

                    <div class="mb-2" :class="item ? 'col-6' : 'col-lg-6 col-xl-3'">
                        <general-input
                            v-model="form.person.email"
                            :label="item ? 'Inbrenger email' : 'Email'"
                            placeholder="Zoek op email"
                            @input="emitValue"
                        />
                    </div>

                    <div class="mb-2" :class="item ? 'col-6' : 'col-lg-6 col-xl-3'">
                        <general-input
                            v-model="form.person.bid_number"
                            :label="item ? 'Client biednummer' : 'Vast biednummer'"
                            placeholder="Zoek op biednummer"
                            @input="emitValue"
                        />
                    </div>

                    <div class="mb-2" :class="item ? 'col-12' : 'col-lg-6'">
                        <general-input
                            v-model="form.person.address"
                            :label="item ? 'Inbrenger adres' : 'Adres'"
                            placeholder="Zoek op adres"
                            @input="emitValue"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralInput from '../Input/GeneralInput';
import Multiselect from 'vue-multiselect';
import { mapGetters, mapActions } from 'vuex';
import CategoryService from '@/services/category-service.js';
import AuctionService from '@/services/auction-service.js';

export default {
    components: {
        GeneralInput,
        Multiselect,
    },
    props: {
        person: {
            type: Boolean,
            default: false,
        },

        item: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => ({ 
                person: {
                    bid_number: null,
                    code: null,
                    name: null,
                    email: null,
                    address: null,
                },

                item: {
                    tag: null,
                    category_id: null,
                    title_description: null,
                    auction_order_number: null,
                    auction_id: null,
                }
            })
        }
    },
    data: function () { return {
        form: this.value,

        tagOptions: [],
        categoryOptions: [],
        auctionOptions: [],

        selectedCategory: null,
        selectedTag: null,
        selectedAuction: null,
        isFetchingCategories: false,
        isFetchingAuctions: false,
    }},
    computed: {
        ...mapGetters([
            'isFetchingTags',
        ])
    },
    methods: {
        ...mapActions([
            'fetchTags',
        ]),

        clearForm(type) {
            if (type == 'item') {
                this.selectedCategory = null;
                this.selectedTag = null;
            }

            for (let key in this.form[type]) {
                this.form[type][key] = null;
            }

            this.$emit('input', this.form);
        },

        async doFetchTags() {
            const response = await this.fetchTags();
            
            this.tagOptions = [...response].sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);

            this.selectedTag = this.tagOptions.find(el => this.form.item.tag == el.id);
        },

        async doFetchCategories() {
            this.isFetchingCategories = true;

            const response = await CategoryService.getAll();
            
            this.categoryOptions = [...response.data].sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
            this.selectedCategory = this.categoryOptions.find(el => this.form.item.category_id == el.id);
            this.isFetchingCategories = false;
        },

        async doFetchAuctions() {
            this.isFetchingAuctions = true;

            const response = await AuctionService.getAll();
            
            this.auctionOptions = [...response.data].sort((a, b) => new Date(a.start) < new Date(b.start) ? 1 : -1);
            this.selectedAuction = this.auctionOptions.find(el => this.form.auction_id == el.id);

            this.isFetchingAuctions = false;
        },

        init() {
            if (this.item) {
                this.doFetchTags();
                this.doFetchCategories();
                this.doFetchAuctions();
            }
        },

        emitValue() {
            if (this.item) {
                this.form.item.tag = this.selectedTag ? this.selectedTag.id : null;
                this.form.item.category_id = this.selectedCategory ? this.selectedCategory.id : null;
                this.form.item.auction_id = this.selectedAuction ? this.selectedAuction.id : null;
            }

            this.$emit('input', this.form);
        }
    },
    created: function () {
        this.init();
    }
}
</script>

<style lang="scss">
.filter-options {
    &-label {
        font-weight: 600;
        font-size: 1rem;
        margin-bottom: 0.25rem;
        color: black;
    }

    &-heading {
        font-size: 1.2rem;
        font-weight: 500;
        align-self: last baseline;
    }
}
</style>


// WEBPACK FOOTER //
// FilterOptions.vue?168cf152